export default "__VITE_ASSET__CjOwPzw1__"